(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hr-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Transformation gallery
    var stageImg = document.querySelector('[data-hr-large]');
    var stageWrap = document.querySelector('[data-hr-stage]');
    var thumbs = document.querySelectorAll('[data-hr-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (stageImg) stageImg.src = btn.getAttribute('data-src');
        if (stageWrap) stageWrap.style.aspectRatio = btn.getAttribute('data-ratio');
        thumbs.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });

    // FAQ accordion — single open
    var faqToggles = document.querySelectorAll('[data-hr-faq-toggle]');
    faqToggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var row = t.closest('[data-hr-faq]');
        var wasOpen = row.classList.contains('is-open');
        document.querySelectorAll('[data-hr-faq]').forEach(function (r) {
          r.classList.remove('is-open');
          var s = r.querySelector('.hr-faq__sign'); if (s) s.textContent = '+';
          var q = r.querySelector('.hr-faq__q'); if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          row.classList.add('is-open');
          var s2 = row.querySelector('.hr-faq__sign'); if (s2) s2.textContent = '−';
          t.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Smooth-scroll CTAs to the offer
    document.querySelectorAll('a[href="#hr-offer"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('hr-offer');
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["novelve-library-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.nv-lib');
    if (!root) return;
    var tabs = root.querySelectorAll('.nv-lib__tab');
    var cards = root.querySelectorAll('.nv-lib__card');
    var empty = root.querySelector('.nv-lib__empty');
    function apply(cat) {
      var shown = 0;
      cards.forEach(function (c) {
        var match = cat === 'all' || c.getAttribute('data-category') === cat;
        c.classList.toggle('is-hidden', !match);
        if (match) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        apply(t.getAttribute('data-cat'));
      });
    });
    apply('all');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.querySelector('.nvc-form');
    if (!form) return;
    var stamp = form.querySelector('[name="contact[form_loaded_at]"]');
    if (stamp) stamp.value = Date.now();
    form.addEventListener('submit', function (e) {
      var tooFast = stamp && (Date.now() - Number(stamp.value) < 3000);
      var pot = form.querySelector('[name="contact[website]"]');
      var potted = pot && pot.value.trim() !== '';
      if (tooFast || potted) e.preventDefault(); // silent
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
